module.exports = __webpack_public_path__ + "img/slide_2.7d7199a1.jpg";